<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">

            <div class="mb-4 avatar-md mx-auto">
              <div class="avatar-title rounded-circle bg-white">
                <i class="mdi mdi-check h1 mb-0 text-success"></i>
              </div>
            </div>

            <h4>{{ $t('lwa.callback.success') }}</h4>
            <p class="text-muted">
              {{ $t('lwa.callback.message') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "LwaRedirect",
  page() {
    return {
      title: this.$t('lwa.callback.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      window.close()
    }, 2000)
  }
}
</script>

